import { render, staticRenderFns } from "./Beginner.vue?vue&type=template&id=743fe74b&"
import script from "./Beginner.vue?vue&type=script&lang=js&"
export * from "./Beginner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports